export { CustomMatSvgIconDirective } from './lib/directive/custom-mat-svg-icon.directive';
export { testInjectAppIcons } from './lib/test/test-inject-app-icons';
